import { QuizPlayerContentFragment } from '../graphql/fragments/generated/QuizPlayerContent';

const getQuestionIds = (content?: QuizPlayerContentFragment) => {
  if (!content) {
    return [];
  }

  return content.quizQuestionsConfig.questions.map((question) => question.id);
};

export default getQuestionIds;
